// services/youtubeBackendService.js
// Frontend service to connect to the backend API

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'https://ij-backend.onrender.com';

/**
 * Fetch regular videos from backend API
 */
export async function getChannelVideos(maxVideos = 50, useCache = true) {
  try {
    const url = `${BACKEND_URL}/api/videos?maxVideos=${maxVideos}&refresh=${!useCache}`;
    console.log('🎬 Fetching videos from backend API...');

    const response = await fetch(url);
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

    const result = await response.json();
    if (result.status === 'success') {
      console.log(`✅ Loaded ${result.count} videos from ${result.source}`);
      return result.data;
    } else {
      throw new Error(result.message || 'Failed to fetch videos');
    }
  } catch (error) {
    console.error('❌ Error fetching videos from backend:', error);
    throw error;
  }
}

/**
 * Fetch Shorts from backend API
 */
export async function getChannelShorts(useCache = true) {
  try {
    const url = `${BACKEND_URL}/api/shorts?refresh=${!useCache}`;
    console.log('⚡ Fetching shorts from backend API...');

    const response = await fetch(url);
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

    const result = await response.json();
    if (result.status === 'success') {
      console.log(`✅ Loaded ${result.count} shorts from ${result.source}`);
      return result.data;
    } else {
      throw new Error(result.message || 'Failed to fetch shorts');
    }
  } catch (error) {
    console.error('❌ Error fetching shorts from backend:', error);
    throw error;
  }
}

/**
 * Fetch single video by ID
 */
export async function getVideoById(videoId) {
  try {
    const url = `${BACKEND_URL}/api/videos/${videoId}`;
    const response = await fetch(url);
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

    const result = await response.json();
    if (result.status === 'success') return result.data;
    throw new Error(result.message || 'Failed to fetch video');
  } catch (error) {
    console.error('Error fetching video:', error);
    throw error;
  }
}

/**
 * Get channel information
 */
export async function getChannelInfo() {
  try {
    const url = `${BACKEND_URL}/api/channel-info`;
    const response = await fetch(url);
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

    const result = await response.json();
    if (result.status === 'success') return result.data;
    throw new Error(result.message || 'Failed to fetch channel info');
  } catch (error) {
    console.error('Error fetching channel info:', error);
    // Fallback data
    return {
      name:        'India Juncation News',
      handle:      '@IndiaJuncationnews',
      url:         'https://www.youtube.com/@IndiaJuncationnews',
      videosUrl:   'https://www.youtube.com/@IndiaJuncationnews/videos',
      shortsUrl:   'https://www.youtube.com/@IndiaJuncationnews/shorts',
      description: 'Latest news and ground reports from India',
    };
  }
}

/**
 * Check if backend is running
 */
export async function checkBackendHealth() {
  try {
    const url = `${BACKEND_URL}/api/health`;
    const response = await fetch(url);
    if (!response.ok) return false;
    const result = await response.json();
    return result.status === 'success';
  } catch (error) {
    console.error('Backend health check failed:', error);
    return false;
  }
}

/**
 * Clear backend cache (admin function)
 */
export async function clearCache() {
  try {
    const url = `${BACKEND_URL}/api/cache/clear`;
    const response = await fetch(url, { method: 'POST' });
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    const result = await response.json();
    return result.status === 'success';
  } catch (error) {
    console.error('Error clearing cache:', error);
    return false;
  }
}

export default {
  getChannelVideos,
  getChannelShorts,
  getVideoById,
  getChannelInfo,
  checkBackendHealth,
  clearCache,
};